import React from "react"

export default function Stepper({ count }) {
  const Steps = () => {
    switch (count) {
      case 0:
        return (
          <ul className="list">
            <li className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
          </ul>
        )

      case 1:
        return (
          <ul className="list">
            <li style={{ border: "2px solid #ff0000" }} className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
          </ul>
        )

      case 2:
        return (
          <ul className="list">
            <li style={{ border: "2px solid #ff0000" }} className="item"></li>
            <li style={{ border: "2px solid #ff0000" }} className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
          </ul>
        )

      case 3:
        return (
          <ul className="list">
            <li style={{ border: "2px solid #ff0000" }} className="item"></li>
            <li style={{ border: "2px solid #ff0000" }} className="item"></li>
            <li style={{ border: "2px solid #ff0000" }} className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
          </ul>
        )

      case 4:
        return (
          <ul className="list">
            <li style={{ border: "2px solid #ff0000" }} className="item"></li>
            <li style={{ border: "2px solid #ff0000" }} className="item"></li>
            <li style={{ border: "2px solid #ff0000" }} className="item"></li>
            <li style={{ border: "2px solid #ff0000" }} className="item"></li>
            <li className="item"></li>
          </ul>
        )

      case 5:
        return (
          <ul className="list">
            <li style={{ border: "2px solid #27AE60" }} className="item"></li>
            <li style={{ border: "2px solid #27AE60" }} className="item"></li>
            <li style={{ border: "2px solid #27AE60" }} className="item"></li>
            <li style={{ border: "2px solid #27AE60" }} className="item"></li>
            <li style={{ border: "2px solid #27AE60" }} className="item"></li>
          </ul>
        )

      default:
        return (
          <ul className="list">
            <li className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
            <li className="item"></li>
          </ul>
        )
    }
  }
  return <div>{Steps()}</div>
}
